export default {
  namespaced: true,
  state: {
    contract_type: [
      { name: '未選択', value: '未選択' },
      { name: '新規', value: '新規' },
      { name: '新規(自社割賦)1', value: '新規(自社割賦)1' },
      { name: '新規(自社割賦)2', value: '新規(自社割賦)2' },
      { name: '新規(自社割賦)3', value: '新規(自社割賦)3' },
      { name: '引継', value: '引継' },
      { name: '内容変更', value: '内容変更' }
    ],

    cancel_type: [
      { name: '未選択', value: '未選択' },
      { name: '中途解約', value: '中途解約' },
      { name: 'CXL', value: 'CXL' },
      { name: '強制解約', value: '強制解約' }
    ],

    media: [
      { name: '未選択', value: '未選択' },
      { name: '貼り紙', value: '貼り紙' },
      { name: 'HP', value: 'HP' },
      { name: '紹介', value: '紹介' },
      { name: 'DM', value: 'DM' },
      { name: 'その他', value: 'その他' }
    ],

    office: [
      { name: '未選択', value: '未選択' },
      { name: '仙台', value: '仙台' },
      { name: '札幌', value: '札幌' },
      { name: '名古屋', value: '名古屋' },
      { name: '福岡', value: '福岡' },
      { name: '新宿', value: '新宿' },
      { name: '大宮', value: '大宮' },
      { name: '高松', value: '高松' },
      { name: '高崎', value: '高崎' },
      { name: '東京', value: '東京' },
      { name: '大阪', value: '大阪' }
    ],

    payment_type: [
      { name: '未選択', value: '未選択' },
      { name: '一括', value: '一括' },
      { name: '一括(他社入金カード)', value: '一括(他社入金カード)' },
      { name: '信販九州日本信販', value: '信販九州日本信販' },
      { name: '信販SP', value: '信販SP' },
      // { name: '信販SP0', value: '信販SP0' },
      { name: '信販ニチクレ', value: '信販ニチクレ' },
      { name: '信販アスマイル', value: '信販アスマイル' },
      { name: '信販ライフティ', value: '信販ライフティ' },
      // { name: '信販ライフティ2.5', value: '信販ライフティ2.5' },
      { name: '信販ダブルラック', value: '信販ダブルラック' },
      { name: '自社割賦', value: '自社割賦' },
      { name: 'のみ(旧料金 9800)', value: 'のみ(旧料金 9800)' },
      { name: 'のみ(旧料金 12400)', value: 'のみ(旧料金 12400)' },
      { name: 'のみ(未就学児 5000)', value: 'のみ(未就学児 5000)' },
      { name: 'のみ(小学生 8000)', value: 'のみ(小学生 8000)' },
      { name: 'のみ(中1~中3.9月 11000)', value: 'のみ(中1~中3.9月 11000)' },
      { name: 'のみ(中学受験 13000)', value: 'のみ(中学受験 13000)' },
      { name: 'のみ(中3.10月~高校生 15000)', value: 'のみ(中3.10月~高校生 15000)' },
      { name: 'のみ(高校生 6000)', value: 'のみ(高校生 6000)' },
      { name: 'のみ(10000)', value: 'のみ(10000)' },
      { name: 'のみ(12500)', value: 'のみ(12500)' },
      { name: 'のみ(16700)', value: 'のみ(16700)' },
      { name: 'のみ(20000)', value: 'のみ(20000)' }
    ],

    text_type: [
      { name: '未選択', value: '未選択' },
      { name: 'JPN', value: 'JPN' },
      { name: 'ウィンベック', value: 'ウィンベック' },
      { name: 'ファラウェイ', value: 'ファラウェイ' },
      { name: 'JPN・ウィンベック', value: 'JPN・ウィンベック' },
      { name: 'JPN・ファラウェイ', value: 'JPN・ファラウェイ' },
      { name: 'ファラウェイ・ウィンベック', value: 'ファラウェイ・ウィンベック' },
      { name: '創拓社', value: '創拓社' },
      { name: 'なし', value: 'なし' }
    ],

    payments_number: [
      { name: 0, value: 0 },
      { name: 1, value: 1 },
      { name: 2, value: 2 },
      { name: 3, value: 3 },
      { name: 4, value: 4 },
      { name: 5, value: 5 },
      { name: 6, value: 6 },
      { name: 7, value: 7 },
      { name: 8, value: 8 },
      { name: 9, value: 9 },
      { name: 10, value: 10 },
      { name: 11, value: 11 },
      { name: 12, value: 12 },
      { name: 13, value: 13 },
      { name: 14, value: 14 },
      { name: 15, value: 15 },
      { name: 16, value: 16 },
      { name: 17, value: 17 },
      { name: 18, value: 18 },
      { name: 19, value: 19 },
      { name: 20, value: 20 },
      { name: 21, value: 21 },
      { name: 22, value: 22 },
      { name: 23, value: 23 },
      { name: 24, value: 24 },
      { name: 25, value: 25 },
      { name: 26, value: 26 },
      { name: 27, value: 27 },
      { name: 28, value: 28 },
      { name: 29, value: 29 },
      { name: 30, value: 30 },
      { name: 31, value: 31 },
      { name: 32, value: 32 },
      { name: 33, value: 33 },
      { name: 34, value: 34 },
      { name: 35, value: 35 },
      { name: 36, value: 36 },
      { name: 37, value: 37 },
      { name: 38, value: 38 },
      { name: 39, value: 39 },
      { name: 40, value: 40 },
      { name: 41, value: 41 },
      { name: 42, value: 42 },
      { name: 43, value: 43 },
      { name: 44, value: 44 },
      { name: 45, value: 45 },
      { name: 46, value: 46 },
      { name: 47, value: 47 },
      { name: 48, value: 48 }
    ],

    method: [
      { name: '未選択', value: 0 },
      { name: '振込', value: 1 },
      { name: '現金', value: 2 },
      { name: 'Coiney', value: 3 }
    ],

    deposit_item: [
      { name: '未選択', value: 0 },
      { name: '普通', value: 1 },
      { name: '当座', value: 2 }
    ],

    factor_check: [
      { name: '未選択', value: 0 },
      { name: '済', value: 1 },
      { name: '未', value: 2 },
      { name: '無', value: 3 }
    ],

    ledger_check: [
      { name: '未選択', value: 0 },
      { name: '済', value: 1 },
      { name: '未', value: 2 },
      { name: '無', value: 3 }
    ],

    cancel_check: [
      { name: '未選択', value: 0 },
      { name: '済', value: 1 },
      { name: '未', value: 2 },
      { name: '無', value: 3 }
    ],

    change_check: [
      { name: '未選択', value: 0 },
      { name: '済', value: 1 },
      { name: '未', value: 2 },
      { name: '無', value: 3 }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    contract_type (state) { return state.contract_type },
    cancel_type (state) { return state.cancel_type },
    media (state) { return state.media },
    office (state) { return state.office },
    payment_type (state) { return state.payment_type },
    text_type (state) { return state.text_type },
    payments_number (state) { return state.payments_number },
    method (state) { return state.method },
    deposit_item (state) { return state.deposit_item },
    factor_check (state) { return state.factor_check },
    ledger_check (state) { return state.ledger_check },
    cancel_check (state) { return state.cancel_check },
    change_check (state) { return state.change_check }
  }
}



// WEBPACK FOOTER //
// ./src/store/agreements.js